import { ReactNode, useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { EmptyBoxContent, MarvinEmpty} from './EmptyBox.styled';
import { useStore } from '@store/appStore';
import S_Icon2 from "@assets/svg/s_icon_2.svg";
import { CenterDiv } from '@components/Pages/ErrorPage/ErrorPage.styled';
import { Attention, LottieWrapper, TextBubble } from '@components/ScheduleErrorContainer/ScheduleErrorContainer';
import Arrow_Icon from "@assets/svg/d-arrow.svg";
import M_Arrow_Icon from "@assets/svg/m-arrow.svg";
import Lottie from 'react-lottie-player';
import Marvin_Json from '@lotties/sherlock.json'
import Sherlock_Marvin from "@assets/svg/sherlock.svg";


type Icons = 'list' | 'users' | 'user' | 'graph' | 'documents';

interface IProps { 
  text:string,
  icon?: ReactNode,
  marvin?: boolean,
  animated?: boolean,
  Graphic?: Icons,
}

export const EmptyBox = (props: IProps) => {
  const {client } = useStore();
  const i18t = useI18n();

  const HandleIcon = () => {
    switch(props.Graphic) {
      case 'list':
        return <S_Icon2 />
        break;
      case 'user':
        return <S_Icon2 />
        break;
      case 'users':
        return <S_Icon2 />
        break;
      case 'documents':
        return <S_Icon2 />
        break;
      case 'graph':
        return <S_Icon2 />
        break;
      default:
        return <S_Icon2 />
    } 
  }

  const SherlockMarvin = {
    loop: true,
    animationData: Marvin_Json,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  
  return (<>
      {props.marvin?
      <MarvinEmpty>
        <CenterDiv>
          <TextBubble>
            <Attention> {i18t.t(props?.text)}</Attention>
            <Arrow_Icon />
            <M_Arrow_Icon />
          </TextBubble>
        {props.animated?<LottieWrapper>
          <Lottie {...SherlockMarvin} play style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} />
        </LottieWrapper>
        :
        <Sherlock_Marvin />}
        </CenterDiv>
      </MarvinEmpty>
      :
      <EmptyBoxContent>
        <div>
          {HandleIcon()}
        </div>
        <p>{i18t.t(props?.text)}</p>
      </EmptyBoxContent>}
  </>);
};

export default EmptyBox;
